<template>
  <div class="project-detail">
    <div class="project-info">
      <h2>
        {{ $route.params.slug ? $route.params.slug : "⚠️ Name not found" }}
      </h2>
      <!-- <h2>
        {{ $route.params.slug ? $route.params.slug : "⚠️ Slug not found" }}
      </h2>
      <h2>{{ $route.params.id ? $route.params.id : "⚠️ ID not found" }}</h2>
      <h2>
        {{ $route.params.id ? $route.params.thumb : "⚠️ Thumbnail not found" }}
      </h2> -->
      <p class="description--short">
        {{
          $route.params.id
            ? $route.params.descriptionShort
            : "⚠️ Description not found"
        }}
      </p>
      <p class="description--long">
        {{
          $route.params.id
            ? $route.params.descriptionLong
            : "⚠️ Description not found"
        }}
      </p>
    </div>
    <div class="project-items"></div>

    <div class="project-items">
      <div v-if="$route.params.imgTitle01">
        <h3>{{ $route.params.imgTitle01 }}</h3>
        <img :src="`${$route.params.imgPath01}`" />
      </div>
      <div v-if="$route.params.imgTitle02">
        <h3>{{ $route.params.imgTitle02 }}</h3>
        <img :src="`${$route.params.imgPath02}`" />
      </div>
      <div v-if="$route.params.imgTitle03">
        <h3>{{ $route.params.imgTitle03 }}</h3>
        <img :src="`${$route.params.imgPath03}`" />
      </div>
      <div v-if="$route.params.imgTitle04">
        <h3>{{ $route.params.imgTitle04 }}</h3>
        <img :src="`${$route.params.imgPath04}`" />
      </div>
      <div v-if="$route.params.imgTitle05">
        <h3>{{ $route.params.imgTitle05 }}</h3>
        <img :src="`${$route.params.imgPath05}`" />
      </div>
    </div>

    <router-link class="btn" to="/resume/projects"
      >Back to Projects</router-link
    >
  </div>
</template>

<script>
  import { projects } from "../../data.js"
  export default {
    name: "ProjectDetail",
    // props: [projects],
    data() {
      return {
        // projects: null,
        // router: this.$route.params.name,
        // id: this.$route.params.id,
      }
    },
    mounted() {
      //   this.getProject()
      // },
      // methods: {
      //   async getProject() {
      //     try {
      //       let response = projects
      // console.log("this.router = " + this.router)
      // console.log(projects)
      //       console.log("response.data = " + response.data)
      //       this.projects = project.slug === this.router
      //       console.log("this.projects = " + this.projects)
      //     } catch (error) {
      //       console.log("error.response = " + error.response)
      //     }
      //   },
    },
  }
</script>

<style lang="scss"></style>
